import get from "lodash/get";
import find from "lodash/find";
import some from "lodash/some";
import isEqual from "lodash/isEqual";
import { hasSetsReps } from "./actuals";

/**
 * Generates an array of movement options based on the active exercise, active user, and athlete.
 *
 * @param {Object} activeExercise - The active exercise object.
 * @param {Object} activeUser - The active user object.
 * @param {Object} athlete - The athlete object.
 * @return {Array} An array of movement options.
 */
export const getMovementsData = (activeExercise, activeUser, athlete) => {
  let movementOptions = [];
  const populateMovementOptions = (primaryString, currentPrimary) => {
    const formattedMovement =
      primaryString.charAt(0).toUpperCase() + primaryString.slice(1);
    const movementPrimaryRepMax = get(
      activeExercise,
      `repMaximums.${primaryString}`
    );

    if (primaryString !== "assistant" && primaryString !== "other") {
      movementOptions.push({
        movement: primaryString,
        customizedRM: undefined,
        repMaximum: movementPrimaryRepMax,
        movementLabel: formattedMovement,
        disabled: primaryString === "assistant",
      });
    }
    currentPrimary.map((item) => {
      if (
        (!activeExercise.parameters && !hasSetsReps(item)) ||
        (!hasSetsReps(activeExercise) && !item.parameters) ||
        (activeExercise.parameters &&
          item.parameters &&
          !isEqual(activeExercise.parameters, item.parameters))
      ) {
        return;
      }

      // Since we're iterarting through the coach's exercise library, we need to
      // iterate through the athlere's and get: if they have the current movement and the 1RM if its customized
      const athleteMovement = find(
        athlete.exerciseLibrary[primaryString],
        (athleteExercise) => {
          return athleteExercise.movement === item.movement;
        }
      );
      const doesAthleteHaveExercise = some(
        athlete.exerciseLibrary[primaryString],
        (athleteExercise) => athleteExercise.movement !== item.movement
      );

      const formatted = [
        "assistant",
        "other",
        "clean",
        "jerk",
        "snatch",
      ].includes(primaryString)
        ? ""
        : ` (${formattedMovement})`;
      if (athleteMovement?.customizedRM && primaryString !== "assistant") {
        movementOptions.push({
          movement: item.movement,
          repMaximum: athleteMovement.repMaximum,
          customizedRM: athleteMovement.customizedRM,
          movementLabel: item.movement + formatted,
          newPrimary: primaryString,
          parameters: item.parameters,
        });
      } else {
        movementOptions.push({
          movement: item.movement,
          repMaximum: doesAthleteHaveExercise
            ? movementPrimaryRepMax
            : item.repMaximum,
          movementLabel: `${item.movement}${formatted}`,
          newPrimary: primaryString,
          parameters: item.parameters,
        });
      }
    });
  };

  // Define a base priority array
  const basePriority = [
    "squat",
    "deadlift",
    "bench",
    "assistant",
    "clean",
    "jerk",
    "snatch",
    "overheadPress",
    "other",
  ];

  // Dynamically generate the priorityOrder object
  const priorityOrder = basePriority.reduce((order, primary) => {
    order[primary] = [
      primary,
      ...basePriority.filter((item) => item !== primary),
    ];
    return order;
  }, {});

  // Get the priority list for the current primary type, putting exercises with the same primary at the top of the list
  const primaryPriority = priorityOrder[activeExercise.primary] || [];

  // Iterate over the priority list and populate movement options
  primaryPriority.forEach((primaryString) => {
    const currentPrimary = activeUser.exerciseLibrary[primaryString] || [];
    populateMovementOptions(primaryString, currentPrimary);
  });

  return movementOptions;
};
